/**
 * PURPOSE: Visibilidad pública de UNA prueba en Hayllis 2.0.
 * RESPONSIBILITIES: Interruptor "Lista de salida pública" y control "Resultados en Hayllis 2.0:
 *   Ocultos / En vivo / Solo oficiales". Cada cambio envía solo su campo a `PUT .../visibility`.
 * COLLABORATORS: PruebaDetailPanel.jsx.
 * ROUTE: winscore/src/area/AtletismoResultadosArea/components/VisibilityPanel.jsx
 */
import React from "react";
import { FiEye } from "react-icons/fi";

import { RESULTS_VISIBILITY_OPTIONS } from "../labels.js";
import { SegmentedControl, Spinner, Switch } from "./ui.jsx";

const VisibilityPanel = ({ prueba, disabled, busy, publicEnabled, onChange }) => {
  const visibility = prueba?.visibility || {};
  const id = `ath-startlist-${prueba?.id}`;
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-3 border-b border-slate-100 bg-slate-50/60 px-4 py-3">
      <span className="inline-flex items-center gap-1.5 text-xs font-black uppercase tracking-wide text-slate-500">
        <FiEye aria-hidden="true" /> Publicación
        {busy ? <Spinner className="h-3.5 w-3.5" /> : null}
      </span>
      <Switch
        id={id}
        checked={Boolean(visibility.startList)}
        onChange={(checked) => onChange({ startList: checked })}
        disabled={disabled || busy}
        label="Lista de salida pública"
      />
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-semibold text-slate-700">Resultados en Hayllis 2.0:</span>
        <SegmentedControl
          options={RESULTS_VISIBILITY_OPTIONS}
          value={visibility.results || "off"}
          onChange={(results) => onChange({ results })}
          disabled={disabled || busy}
          size="sm"
          ariaLabel="Resultados en Hayllis 2.0"
        />
      </div>
      {!publicEnabled ? (
        <span className="text-[11px] font-semibold text-slate-400">
          La publicación pública está apagada en el servidor: estos ajustes se aplicarán cuando se encienda.
        </span>
      ) : null}
    </div>
  );
};

export default VisibilityPanel;
